import { useEffect, useState } from 'react'
import { subscribeExportProgress } from '../utils/exportProgressBus'

export function useExportRunning(): boolean {
  const [running, setRunning] = useState(false)

  useEffect(() => {
    const unsub = subscribeExportProgress((state: any) => {
      // Single-job bus shape: { visible, phase }
      const visible = !!(state && state.visible)
      const phase = state?.phase
      const isActive =
        visible && (phase === 'creating' || phase === 'preparing' || phase === 'uploading')
      setRunning(!!isActive)
    })
    return () => unsub()
  }, [])

  return running
}
